import "./VideoMentionMarker.css";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { TextMono } from "@ui/typography/TextMono";
import { Show } from "solid-js";

export type VideoMentionMarkerProps = {
	index: number;
	/** A range within its video rather than the whole video, so shown with scissors. */
	clip?: boolean;
	theme?: "dark" | "light";
}

export const VideoMentionMarker = (props: VideoMentionMarkerProps) => {
	const theme = () => props.theme ?? "light";

	return (
		<TextMono 
			as="span" 
			class="video-mention-marker" 
			classList={{
				"video-mention-marker--dark": theme() === "dark",
				"video-mention-marker--light": theme() === "light",
				"video-mention-marker--clip": props.clip ?? false,
			}}
			color="purple" 
			weight="bold"
		>
			<Show when={props.clip}>
				<MaterialSymbol
					class="video-mention-marker__clip-symbol"
					symbol="content_cut"
					relativeSize={0.9}
				/>
			</Show>
			{props.index}
		</TextMono>
	)
}
